/* eslint-disable react/no-unused-state */
/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as MMEUtils from '../../util/MMEUtils';
import * as mmeActions from '../../actions/mmeActions';
import MMEGridView from '../common/mmeGrid/MMEGridView';
import { REPORT_TYPE_OPTIONS_MAP } from './MMEConstants';

const defaultColumnHeaderDef = {
  label: '',
  name: '',
  sortOrder: MMEUtils.SORT_DIRECTION.NONE,
  sortKey: '',
};

class MMETable extends Component {

  constructor(props) {
    super(props);
    this.state = {
      mmeTableList: [],
      activeMMETable: {},
    };
  }

  UNSAFE_componentWillMount() {
    if (
      this.props &&
      this.props.mmeTableList &&
      this.props.mmeTableList.length > 0
    ) {
      const activeMMETable = this.props.mmeTableList.filter(
        mmeTable => mmeTable.isActive,
      )[0];
      if (activeMMETable) {
        this.setState(
          {
            columnDefinitions: activeMMETable.columnHeaderList.map(
              columnHeader => ({
                ...defaultColumnHeaderDef,
                ...columnHeader,
              }),
            ),
            activeMMETable,
          },
        );
      }
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.mmeTableList !== nextProps.mmeTableList) {
      if (
        nextProps.mmeTableList &&
        nextProps.mmeTableList.length > 0
      ) {
        let activeMMETable = nextProps.mmeTableList.filter(
          mmeTable => mmeTable.isActive,
        )[0];
        if (activeMMETable) {
          if (this.state.activeMMETable === activeMMETable) {
            // InActive entry deleted
            this.setState({ mmeTableList: nextProps.mmeTableList });
          } else {
            if (
              activeMMETable.sortOrder &&
              activeMMETable.sortOrder !== MMEUtils.SORT_DIRECTION.NONE
            ) {
              activeMMETable = MMEUtils.sortMMETable(
                activeMMETable,
                this.props.reportType,
              );
            }
            this.setState(
              {
                mmeTableList: nextProps.mmeTableList,
                columnDefinitions: activeMMETable.columnHeaderList.map(
                  columnHeader => ({
                    ...defaultColumnHeaderDef,
                    ...columnHeader,
                  }),
                ),
                activeMMETable,
              },
            );
          }
        }
      } else {
        this.setState({ activeMMETable: {} });
      }
    }
  }

  getCelElementList = type => {
    switch (type) {
      case 'SR': return MMEUtils.DEFAULT_CELL_ELEMENTS;
      case 'DCR': return MMEUtils.DEFAULT_DCR_CELL_ELEMENTS;
      case 'DR': return MMEUtils.DEFAULT_DR_CELL_ELEMENTS;
      default: return [];
    }
  }

  handleSort = (sortOrder, sortKey, sortColumnIndex) =>
  this.props.mmeActions.updateMMEGrid(
    this.state.activeMMETable.idKey,
    {
      sortOrder,
      sortKey,
      sortColumnIndex,
    },
  );

  renderMMETable = () => {
    if (this.state.activeMMETable && Object.keys(this.state.activeMMETable).length > 0) {
      const { mmeTableList, reportType } = this.props;
      return (
        <div className="mme-viewer-table-main-wrapper">
          <div className="row expanded">
            <div className="columns large-12 mme-viewer-child-wrapper-left">
              <div className="row expanded top-controls-wrapper">
                <div className="row expanded custom-mme-table">
                  <div className="columns large-12 padding-left-0 padding-right-0">
                    <MMEGridView
                      data-test="PrivateEyeViewComponent"
                      ref={node => (this.newPrivateEyeViewerGrid = node)}
                      tableData={this.state.activeMMETable}
                      selectedBaseIndex={mmeTableList[0].selectedBase}
                      cellElementList={this.getCelElementList(reportType)}
                      onSort={this.handleSort}
                      showSave
                      mmeView
                      placeholder={`${REPORT_TYPE_OPTIONS_MAP[reportType].toUpperCase()} REPORT`}
                      warningText="Please enter report name to save"
                      reportType={reportType}
                      firstHeaderCellElementList={MMEUtils.DEFAULT_FIRST_HEADER_CELL_ELEMENTS}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }
    return null;
  }


  render() {
    return (
      <div data-test="MMETableComponent">
        {this.renderMMETable()}
      </div>
    );
  }
}

MMETable.propTypes = {
  mmeTableList: PropTypes.arrayOf(PropTypes.object),
  mmeActions: PropTypes.shape({
    updateMMEGrid: PropTypes.func,
  }),
  reportType: PropTypes.string,
};

function mapStateToProps(state) {
  return {
    mmeTableList: state.mme.mmeTableList,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    mmeActions: bindActionCreators(mmeActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MMETable);
